<template>
    <div :key="tick+'ncbgb2'"   class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        Profile
                    </h3>
                </div>
                <div class="col text-right">
                    <base-button size="sm" type="secondary" @click="$store.dispatch('profiles/getProfiles')" icon="fas fa-sync-alt"></base-button>
                   <base-button type="primary" size="sm" v-on:click="$router.push('/users/profiles_create')" icon="ni ni-fat-add"></base-button>
                </div>
            </div>
        </div>
        <!---<div v-if="$store.getters['profiles/showProfiles'].length > 0 && !$store.getters['profiles/isLoading'] && typeof $store.getters['profiles/showProfiles'][0].id !== 'undefined'" class="table-responsive">--->
        <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <th>id</th>
                    <!---<th v-if="isAdmin">Organisation</th> --->
                    <TableHeadFilter title="Name" v-model="tableOptions.filter.name" :has-filter="true" filter-type="input" v-on:input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Beschäftigungsart" v-model="tableOptions.filter.employment" :has-filter="true" filter-type="dropdown" :dropdown-list="empOptionsTransform" v-on:input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Status" v-model="tableOptions.filter.isActive" :has-filter="true" filter-type="dropdown" :dropdown-list="[{name: 'aktiv', id: 'true'},{name: 'inaktiv', id: 'false'}]" v-on:input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Benutzer" v-model="tableOptions.filter.user" :has-filter="true" filter-type="dropdown" :dropdown-list="users" property="email" v-on:input="changePage(1)"></TableHeadFilter>
                    <th></th>
                </template>

                <template slot-scope="{row,index}">
                    <th v-on:dblclick="editable.push(row.id)" scope="row">
                        <div v-if="isLoadingData" class="loading"> </div><div v-else>{{row.id}}</div>
                    </th>
                    <!----<td v-if="isAdmin" v-on:dblclick="editable.push(row.id)" >
                        <div v-if="isLoadingData" class="loading"> </div><div v-else>{{row.user.customer.name}}</div>
                    </td>--->
                    <td v-on:dblclick="editable.push(row.id)" >
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><span v-if="!editable.includes(row.id) || isLoading">{{row.name}}</span>
                        <base-input v-else v-model="row.name" class="form-no-padding" input-classes="form-no-padding"></base-input></div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)" >
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><span v-if="!editable.includes(row.id) || isLoading">{{row.employment}}</span>
                        <select v-else v-model="row.employment"
                                class="custom-select form-control form-no-padding">
                            <option v-for="o in empOptions" :key="o" :value="o">{{ o }}</option>
                        </select>
                    </div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)" >
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><switches v-model="row.isActive"
                                  :disabled="!editable.includes(row.id) || isLoading"
                                  theme="bootstrap"
                                  color="primary"
                                  style="padding-left: 2rem;"
                                  text-enabled="aktiv"
                                  text-disabled="inaktiv"></switches></div>
                    </td>
                    <td>
                        <div v-if="isLoadingData" class="loading"> </div><div v-else>{{ row.user.email }}<br>{{ (row.user.location) ? row.user.location.name : '' }}</div>
                    </td>
                    <td class="text-right">
                        <div v-if="isLoadingData" class="loading-button"> </div><div v-else><template>
                            <base-button v-if="!editable.includes(row.id)" v-on:click="editable.push(row.id)" icon="fas fa-pencil-alt" type="secondary" icon-only
                                         title="Quickedit"></base-button>
                            <div v-else>
                                <base-button v-on:click="editable.splice(editable.indexOf(row.id),1)" v-if="!isLoading" icon="fa fa-ban" type="secondary" icon-only
                                                                           title="abbrechen"></base-button>
                                <base-button v-on:click="editProfile(row)" :disabled="isLoading" :icon="(isLoading) ? 'fas fa-circle-notch fa-spin' : 'fas fa-save'" type="primary" icon-only
                                                                            title="speichern"></base-button></div>
                        <base-button v-on:click="$router.push('/users/profiles_edit/'+row.id)" icon="far fa-list-alt" type="primary" icon-only
                                     title="bearbeiten"></base-button>
                        <base-button v-if="!row.delete" type="secondary" :icon="(currentlyLoading.includes(row.id)) ? 'fas fa-circle-notch fa-spin' : 'far fa-trash-alt'" icon-only v-on:click="deleteConfirmation(index)"></base-button>
                        <div v-else style="margin-top: 1rem;"><span  class="text-danger">Sicher? <i class="far fa-trash-alt"></i></span><br>
                            <base-button :key="tick+'ncb2'" v-if="row.delete" size="sm" :disabled="currentlyLoading.includes(row.id)"  icon="fas fa-check" type="danger" v-on:click="deleteIT(row)">Ja</base-button>
                            <base-button v-if="row.delete" size="sm" type="info" icon="fas fa-times" v-on:click="deleteConfirmation(index)">Nein</base-button>
                        </div>
                        </template></div>
                    </td>
                </template>
            </base-table>
        </div>
        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination :total="totalitems" v-on:input="changePage" :value="page"></base-pagination>
        </div>
    </div>
</template>

<script>
    import Switches from "vue-switches";
    import TableHeadFilter from "@/components/TableHeadFilter";
    export default {
        name: "editProfilesTable",
        components:{TableHeadFilter, Switches},
        props: {
            type: {
                type: String
            },
            title: String
        },
        data() {
            return {
                tick: 1,
                editable: [],
                tableOptions: {
                    filter: {
                        name: null,
                        user: null,
                        employment: null,
                        isActive: null,
                    },
                    dateFilter: {
                    },
                    sort:{
                    }},
                userFilter: {active: false, user: null},
                currentlyLoading: [],
                tableData:[
                    {
                        id:0,
                        name:"Keine Daten",
                        isActive:false,
                        user:{
                            email:'',
                            customer:{
                                name:''
                            },
                            location:{
                                name:''
                            }
                        },
                        createdAt:''
                    }
                ],
                empOptions: ['Vollzeit','Teilzeit','Geringfügig'],
                totalitems:0,
                page:1,
                isLoading: false
            }
        },
        created() {
            this.changePage(this.page);
            if (!this.$store.getters['profiles/isLoading'] && !this.$store.getters['profiles/isReady']) this.$store.dispatch('profiles/getProfiles');
            if (!this.$store.getters['customer/isReady']) this.$store.dispatch('customer/getCustomerCollection');
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            empOptionsTransform() {
                let objs = [];
                this.empOptions.forEach(obj => objs.push({name: obj, id: obj}));
                return objs
            },
            isLoadingData() {
                return this.$store.getters['profiles/isLoading'] || this.isLoading;
            },
            users() {
                return (this.$store.getters['customer/isReady']) ? this.concatUsers(this.$store.getters['customer/showCustomerCollection']).sort((a, b) =>{
                    return a.email.localeCompare(b.email);
                }) : [];
            },
            userFilterUser() {
                return this.userFilter.user;
            },
            isInvalid() {
                return this.$store.getters['profiles/showProfiles'].length === 0 && this.$store.getters['profiles/isLoading'] && typeof this.$store.getters['profiles/showProfiles'][0].id === 'undefined';
            }
        },
        watch: {
            userFilterUser: function () {
                this.changePage(this.page)
            }
        },
        methods: {
            deleteConfirmation(index) {
                if(typeof this.tableData[index].delete === "undefined") {
                    this.tableData[index].delete = false;
                }
                this.tableData[index].delete = !this.tableData[index].delete;
                this.tick++;
            },
            deleteIT(data) {
                return new Promise((resolve, reject) => {
                    this.currentlyLoading.push(data.id);
                    data.delete = false;
                    this.tick++;
                    //this.deleteConfirmation(this.tableData.indexOf(data));
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'DELETE',
                        headers: header,
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/profiles/`+data.id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                                this.$store.dispatch('alert/success','Mitarbeiter-Profil erfolgreich gelöscht.');
                                this.changePage(this.page);
                                this.currentlyLoading.splice(this.currentlyLoading.indexOf(data.id),1);
                                this.tick++;
                            },
                            error => {
                                reject(error);
                                this.$store.dispatch('alert/error','Mitarbeiter-Profil konnte nicht gelöscht werden.');
                                this.currentlyLoading.splice(this.currentlyLoading.indexOf(data.id),1);
                                this.tick++;
                            });
                });
            },
            editProfile(data) {
                return new Promise(() => {
                    this.isLoading = true;
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = JSON.parse(JSON.stringify(data));
                    delete senddata.user;
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/profiles/`+data.id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/success', 'Profil '+response.name+' (ID: '+response.id+') wurde editiert.');
                                this.editable.splice(this.editable.indexOf(data.id),1)
                            },
                            error => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/error', error);
                            });
                });
            },
            concatUsers(customers){
                let users = [];
                customers.forEach(item => {
                    users.push(...item.users)
                });
                return users;
            },
            changePage(page) {
                this.isLoading = true;
                this.getTableData(page).then(
                    response => {
                        this.tableData = response.member;
                        this.totalitems = response.totalItems;
                        this.page = page;
                        this.isLoading = false;
                    }
                )
            },
            getTableData(page){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    let url = process.env.VUE_APP_API_SERVER + `/api/profiles?`+this.getUrlExtension(this.tableOptions.filter,this.tableOptions.sort,this.tableOptions.dateFilter)+`page=` + page;
                    if (this.userFilter.user !== null) url = url + '&user=' + this.userFilter.user;

                    fetch(url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            }
        }
    }
</script>

<style scoped>
    .form-no-padding {
        padding: 0;
        margin: 0;
    }
</style>